import { useState, type FormEvent } from 'react';
import { INSTANCE_LABEL } from '../config';

interface Props {
  onLogin: () => void;
  onEmailLogin: (email: string, password: string) => Promise<void> | void;
  error: string;
}

/**
 * Login screen — tenant-safe. E-mail/password against the instance's
 * auth-api is the primary path; Google goes through auth-api's
 * /authorize redirect (client id lives server-side, never in this bundle).
 */
export function LoginScreen({ onLogin, onEmailLogin, error }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState('');

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLocalError('');
    if (!email || !password) {
      setLocalError('Bitte E-Mail und Passwort eingeben.');
      return;
    }
    setBusy(true);
    try {
      await onEmailLogin(email.trim(), password);
    } finally {
      setBusy(false);
    }
  };

  const shownError = localError || error;

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1>ISSUES</h1>
        <div className="login-subtitle">{INSTANCE_LABEL}</div>
        {shownError && <div className="error" style={{ marginBottom: 18 }}>{shownError}</div>}

        <form onSubmit={submit} style={{ display: 'grid', gap: 10, marginBottom: 14 }}>
          <input
            type="email"
            autoComplete="username"
            placeholder="E-Mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={busy}
          />
          <input
            type="password"
            autoComplete="current-password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
          <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
            {busy ? 'Anmelden …' : 'Anmelden'}
          </button>
        </form>

        <button className="secondary" type="button" onClick={onLogin} style={{ width: '100%' }} disabled={busy}>
          Sign in with Google
        </button>
        <div
          className="muted mono"
          style={{ fontSize: 10, letterSpacing: 1, marginTop: 18, textTransform: 'uppercase' }}
        >
          Issue-Tracking
        </div>
      </div>
    </div>
  );
}
